import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class InstantOfferDetailsSellerValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.id
   * @param {Object} deps.adData
   * @param {Object} deps.appraisal
   * @param {Array}  deps.appointments
   * @param {String} deps.creationDate
   * @param {Object} deps.user
   */
  constructor({id, adData, appraisal, appointments, creationDate, user}) {
    super()
    this._id = id
    this._adData = adData
    this._appraisal = appraisal
    this._appointments = appointments
    this._creationDate = creationDate
    this._user = user
  }

  static createFromApi = ({id, adData, appraisal, appointments, creationDate, user}) =>
    new InstantOfferDetailsSellerValueObject({id, adData, appraisal, appointments, creationDate, user})

  toJSON() {
    return {
      id: this._id,
      adData: this._adData,
      appraisal: this._appraisal,
      appointments: this._appointments,
      creationDate: this._creationDate,
      user: this._user
    }
  }
}
